import React, { useState, useEffect } from 'react';
import styles from './Login.module.css';
import { API_BASE_URL } from '../../config/api';
import { supabase } from '../../config/supabase';
import Cookies from 'js-cookie';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Add useEffect for page title
  useEffect(() => {
    document.title = 'Login - Scholarly';
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Step 1: Authenticate with Supabase directly from frontend
      const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
        email: formData.email,
        password: formData.password
      });

      if (authError) throw new Error(authError.message);

      // Step 2: Send Supabase ID to backend to get MongoDB user data
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: formData.email,
          supabaseId: authData.user.id
        })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error);

      // Store tokens
      localStorage.setItem('token', authData.session.access_token);
      localStorage.setItem('refreshToken', authData.session.refresh_token);
      localStorage.setItem('mongoToken', data.token);
      
      window.location.href = '/';
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Replace the navigate function with direct window location change
  const goToRegister = () => {
    window.location.href = '/register';
  };

  return (
    <div className={styles.loginContainer}>
      <h2 className={styles.title}>Login</h2>

      <form onSubmit={handleSubmit} className={styles.loginForm}>
        <div className={styles.formCollection}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={styles.input}
            required
          />
        </div>

        <div className={styles.formSpacing}></div>

        <div className={styles.formCollection}>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            className={styles.input}
            required
          />
        </div>

        {error && <div className={styles.errorMessage}>{error}</div>}

        <button type="submit" className={styles.btn} disabled={isLoading}>
          {isLoading ? <div className={styles.spinner}></div> : 'Login'}
        </button>
      </form>

      <div className={styles.flipContainer}>
        Don't have an account?
        <button onClick={goToRegister} className={styles.flipBtn}>
          Sign Up
        </button>
      </div>
    </div>
  );
};

export default Login;